import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { asyncWrap } from "../../utils/utils";
import TapGame from "./TapGame";

const SelectTapGame = ({ show, setShow }) => {
  // const { t } = useTranslation();
  const [tapGame, setTapGame] = useState([]);
  const [showTap, setShowTap] = useState(false);
  const [data, setData] = useState([]);

  const color = ["#FEA965", "#CC4056", "#A13964", "#4E866A"];
  const getPuzzleData = async (title) => {
    const [error, result] = await asyncWrap(axios.get(`/users-tapping`));
    if (!result) {
      console.log(error);
      return;
    }

    let data = result.data.data.map((item, i) =>
      i % 3 === 0
        ? { ...item, Color: color[i % 4] }
        : { ...item, Color: color[i % 4] }
    );
    setTapGame(data);
  };

  useEffect(() => {
    if (show || showTap) {
      getPuzzleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, showTap]);

  return (
    <>
      <TapGame show={showTap} setShow={setShowTap} data={data} />
      <Modal fullscreen={true} show={show} onHide={() => setShow(false)}>
        <Modal.Body className="mb-20 p-0 text-center">
          <Row className="p-4">
            {tapGame &&
              tapGame.map((item) => (
                <Col
                  xs={22}
                  style={{
                    marginTop: "40px",
                  }}
                >
                  <Card
                    onClick={() => {
                      setData(item);
                      setShowTap(true);
                    }}
                    style={{
                      backgroundColor: item.Color,
                      height: "160px",
                      boxShadow: "0px 4px 20px rgba(254, 169, 101, 0.5)",
                      borderRadius: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "90px",
                        height: "90px",
                        backgroundColor: "#FFCA9F",
                        borderRadius: "15px",
                        boxDhadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Card.Img
                        src={item.TappingImage}
                        style={{ width: "64px", height: "64px" }}
                      />
                    </div>
                    <Card.Text
                      style={{
                        marginTop: "5px",
                        textAlign: "center",
                        color: "#fff",
                        fontWeight: "500",
                        fontSize: "16px",
                      }}
                    >
                      {item.TappingName}
                    </Card.Text>
                  </Card>
                </Col>
              ))}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SelectTapGame;
